module.exports = __webpack_public_path__ + "static/media/star-pattern.0e0b1aeb.svg";